import TeamList from './TeamList';
import TeamShow from './TeamShow';

export default {
  list: TeamList,
  show: TeamShow,
};
